// extracted by mini-css-extract-plugin
export default {"container":"Mq-z","brandName":"Nq-z","productName":"Oq-z","productNamePdpEnhancements":"Pq-z","breakLongProductName":"Qq-z"};